export class PlatformError extends Error {
    code;
    retryable;
    raw;
    constructor(message, code, retryable, raw) {
        super(message);
        this.code = code;
        this.retryable = retryable;
        this.raw = raw;
        this.name = 'PlatformError';
    }
}
//# sourceMappingURL=adapter.js.map